import { codePointCount } from '../../../utils/contentLimits';
/* eslint-disable no-control-regex -- The API rejects control characters in profile fields. */

export const profileErrorMessage = code => ({
  PROFILE_USERNAME_INVALID: 'settings:usernameInvalid',
  PROFILE_NAME_INVALID: 'settings:nameInvalid',
  PROFILE_LANGUAGE_INVALID: 'settings:languageInvalid',
  PROFILE_IMAGE_INVALID: 'brand:imageFormatError',
  IMAGE_STORAGE_UNAVAILABLE: 'brand:imageError',
})[code];

export function profileFieldError(field, value) {
  const text = String(value || '').trim();
  if (field === 'user_name' && (!text || codePointCount(text) > 64
    || /[/\\?#%\u0000-\u0020\u007f\u200b-\u200f\u202a-\u202e\u2066-\u2069\ufeff]/.test(text)
    || /^(?:\.{1,2}|settings|control)$/i.test(text))) return 'settings:usernameInvalid';
  if (field === 'first_name' && (codePointCount(text) > 160 || /[\u0000-\u001f\u007f]/.test(text))) return 'settings:nameInvalid';
  return null;
}
